import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconShoppingCart1 = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_cart_light"
      data-name="UI icon/cart/light"
      xmlns="http://www.w3.org/2000/svg"
      width="37.39"
      height="34.5"
      viewBox="0 0 37.39 34.5"
    >
      <path
        id="Path_Stroke_"
        data-name="Path (Stroke)"
        d="M29.508,26.834H14.493a5.742,5.742,0,0,1-5.579-4.356L4.616,5.285a1.912,1.912,0,0,0-1.86-1.452h-.84A1.916,1.916,0,0,1,1.916,0h.84A5.742,5.742,0,0,1,8.335,4.356l.348,1.394H31.638a5.752,5.752,0,0,1,5.613,7l-2.13,9.582a5.751,5.751,0,0,1-5.613,4.5ZM9.643,9.584l2.991,11.965A1.912,1.912,0,0,0,14.493,23H29.508a1.905,1.905,0,0,0,1.872-1.5l2.13-9.582a1.917,1.917,0,0,0-1.872-2.332Z"
        fill={color}
      />
      <path
        id="Oval"
        d="M2.875,5.75A2.875,2.875,0,1,0,0,2.875,2.875,2.875,0,0,0,2.875,5.75Z"
        transform="translate(11.5 28.75)"
        fill={color}
      />
      <path
        id="Oval_Copy"
        data-name="Oval Copy"
        d="M2.875,5.75A2.875,2.875,0,1,0,0,2.875,2.875,2.875,0,0,0,2.875,5.75Z"
        transform="translate(26.833 28.75)"
        fill={color}
      />
    </svg>
  );
};

export default IconShoppingCart1;
